/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "yesterday",
        "0": "today",
        "1": "tomorrow",
        "future": {
          "one": "om {0} ulloq unnuarlu",
          "other": "om {0} ulloq unnuarlu"
        },
        "past": {
          "one": "for {0} ulloq unnuarlu siden",
          "other": "for {0} ulloq unnuarlu siden"
        }
      },
      "day-narrow": {
        "-1": "yesterday",
        "0": "today",
        "1": "tomorrow",
        "future": {
          "one": "om {0} ulloq unnuarlu",
          "other": "om {0} ulloq unnuarlu"
        },
        "past": {
          "one": "for {0} ulloq unnuarlu siden",
          "other": "for {0} ulloq unnuarlu siden"
        }
      },
      "day-short": {
        "-1": "yesterday",
        "0": "today",
        "1": "tomorrow",
        "future": {
          "one": "om {0} ulloq unnuarlu",
          "other": "om {0} ulloq unnuarlu"
        },
        "past": {
          "one": "for {0} ulloq unnuarlu siden",
          "other": "for {0} ulloq unnuarlu siden"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "om {0} nalunaaquttap-akunnera",
          "other": "om {0} nalunaaquttap-akunnera"
        },
        "past": {
          "one": "for {0} nalunaaquttap-akunnera siden",
          "other": "for {0} nalunaaquttap-akunnera siden"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "om {0} nalunaaquttap-akunnera",
          "other": "om {0} nalunaaquttap-akunnera"
        },
        "past": {
          "one": "for {0} nalunaaquttap-akunnera siden",
          "other": "for {0} nalunaaquttap-akunnera siden"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "om {0} nalunaaquttap-akunnera",
          "other": "om {0} nalunaaquttap-akunnera"
        },
        "past": {
          "one": "for {0} nalunaaquttap-akunnera siden",
          "other": "for {0} nalunaaquttap-akunnera siden"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "om {0} minutsi",
          "other": "om {0} minutsi"
        },
        "past": {
          "one": "for {0} minutsi siden",
          "other": "for {0} minutsi siden"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "om {0} minutsi",
          "other": "om {0} minutsi"
        },
        "past": {
          "one": "for {0} minutsi siden",
          "other": "for {0} minutsi siden"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "om {0} minutsi",
          "other": "om {0} minutsi"
        },
        "past": {
          "one": "for {0} minutsi siden",
          "other": "for {0} minutsi siden"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "om {0} qaammat",
          "other": "om {0} qaammat"
        },
        "past": {
          "one": "for {0} qaammat siden",
          "other": "for {0} qaammat siden"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "om {0} qaammat",
          "other": "om {0} qaammat"
        },
        "past": {
          "one": "for {0} qaammat siden",
          "other": "for {0} qaammat siden"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "one": "om {0} qaammat",
          "other": "om {0} qaammat"
        },
        "past": {
          "one": "for {0} qaammat siden",
          "other": "for {0} qaammat siden"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "one": "om {0} sekundi",
          "other": "om {0} sekundi"
        },
        "past": {
          "one": "for {0} sekundi siden",
          "other": "for {0} sekundi siden"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "one": "om {0} sekundi",
          "other": "om {0} sekundi"
        },
        "past": {
          "one": "for {0} sekundi siden",
          "other": "for {0} sekundi siden"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "one": "om {0} sekundi",
          "other": "om {0} sekundi"
        },
        "past": {
          "one": "for {0} sekundi siden",
          "other": "for {0} sekundi siden"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "om {0} sapaatip-akunnera",
          "other": "om {0} sapaatip-akunnera"
        },
        "past": {
          "one": "for {0} sapaatip-akunnera siden",
          "other": "for {0} sapaatip-akunnera siden"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "om {0} sapaatip-akunnera",
          "other": "om {0} sapaatip-akunnera"
        },
        "past": {
          "one": "for {0} sapaatip-akunnera siden",
          "other": "for {0} sapaatip-akunnera siden"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "one": "om {0} sapaatip-akunnera",
          "other": "om {0} sapaatip-akunnera"
        },
        "past": {
          "one": "for {0} sapaatip-akunnera siden",
          "other": "for {0} sapaatip-akunnera siden"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "om {0} ukioq",
          "other": "om {0} ukioq"
        },
        "past": {
          "one": "for {0} ukioq siden",
          "other": "for {0} ukioq siden"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "om {0} ukioq",
          "other": "om {0} ukioq"
        },
        "past": {
          "one": "for {0} ukioq siden",
          "other": "for {0} ukioq siden"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "one": "om {0} ukioq",
          "other": "om {0} ukioq"
        },
        "past": {
          "one": "for {0} ukioq siden",
          "other": "for {0} ukioq siden"
        }
      }
    },
    "locale": "kl"
  });
}